<template>
  <!-- Popup Deposit -->
  <el-dialog :title="$t('TEXT_SUCCESS')" :visible.sync="isShowVerifyEmailSuccess" class="deposit-form">
    <div class="popup-inner">
      <div class="item icon-wrapper">
        <i class="el-icon-circle-check"></i>
      </div>
      <div class="item">
        <div class="text-break-word bold">{{ $t('TEXT_SUCCESS') }}</div>
        <p>{{ $t('TEXT_VERIFY_EMAIL_SUCCESS') }}
        </p>
      </div>
      <div class="item item-submit">
        <a class="btn btn-submit" @click="login">{{ $t('BTN_LOGIN') }}</a>
      </div>
    </div>
  </el-dialog>
  <!-- End Popup Deposit -->
</template>

<script>
export default {
  computed: {
    isShowVerifyEmailSuccess: {
      get () {
        return this.$store.getters.isShowVerifyEmailSuccess
      },
      set () {
        this.$store.dispatch('toggleVerifyEmailSuccessForm')
      }
    },
    modalData () {
      return this.$store.getters.modalData
    }
  },
  methods: {
    login () {
      this.$store.dispatch('closeAllModal')
      setTimeout(() => {
        this.$store.dispatch('toggleLoginFormModal')
      }, 0)
    }
  }
}
</script>
